import { MESSAGES_ACTIVITIES } from '@nixi1/nx-constants'

import { setUnreadMessages } from './unreadMessagesAct'
import { getMessagesSuccess, getDeferredMessages, updateMessage, updateMessageStatus } from './messagesAct'
import { fetchAssignedUsersSuccess } from '../assignedUsers'
import { fetchLists } from '../cv_lists'
import { setAllOperatorsAct } from '../operators'
import { fetchUsers, fetchUsersSuccess } from '../cv_users'
import { store } from '../..'
import { apiConversation, operator as operatorApi } from '../../../api'
import { setAllBrandsAct } from '../brands'
import { setAllDelegationsAct } from '../delegations'
import { setUserData } from '../user'
import { addNode, addWall, updateNode } from '../wall'
import { modulesAct, composerAct, poolsActions } from '../../actions'
import { updateExistingCompanyAct } from '../companies'
import { updateTicket, getMnemonics } from '../../mnemonics/actions'
import { success as userUpdate } from '../conversations/user'
import poolLists from '../../poolLists/actions'
import channels from '../../channels/actions'
import categories from '../../categories/actions'
import { updateUser as cvSearchUpdateUser } from '../cv_search'
import composerActions from './composerAct'
import dashNotification from '../../dashNotifications/actions'
import CurrentPlanAct from 'redux/currentPlan/actions'
import inchatActions from 'redux/inchat/actions'
import trackingUserInfoAct from 'redux/actions/conversations/plugins/trackingUserInfoAct'
import trackingUserHistoryAct from 'redux/actions/conversations/plugins/trackingUserHistoryAct'
import sharedResourcesAct from './plugins/sharedResourcesAct'


import { addNewAssignation, removeAssignation } from './socketEvents/assignments'
import { updateUserStatus, updateUserOrder } from './socketEvents/updateUser'

const { dispatch, getState } = store

const canDisplayMessage = ({ filterType, messageType }) => {
  if (filterType === 'all') return true

  const isActivity = MESSAGES_ACTIVITIES.includes(messageType)
  if (filterType === 'activities' && isActivity) return true

  if (filterType === 'messages' && !isActivity) return true

  return false
}

export default async (e) => {
  let event = {}

  try {
    event = JSON.parse(e)

    // Datos guardados en el Store de Redux
    const currentState = getState()
    const {
      tabs: { activeUser },
      cv_users: { users },
      assignedUsers: { users: usersAssigned },
      operators,
      tabs,
      cv_search: { search_users },
      settings: { msgFilterEvent },
      conversations, user: operator
    } = currentState

    const { onlyAssignedConversations } = operator

    switch (event.action) {
      /**
       *  SOCKET CHANNEL --> user.id
       */
      case 'newMessage': {
        const { message, user } = event.data
        if (canDisplayMessage({ filterType: msgFilterEvent, messageType: message.type })) {
          dispatch(getMessagesSuccess(message.userId, [message]))
        }
        if (tabs.users?.some(e => e.id === user.id)) dispatch(userUpdate(user))

        // set unread new messages count
        // if is not loading conversation for the first time.
        // We check that by looking to the lenght of the provided messages
        if (message.type === 'operator' || activeUser === message.userId) {
          dispatch(setUnreadMessages(message.userId, 0))
          const indexUserFound = users.findIndex((_user) => _user.id === user.id)
          if (indexUserFound !== -1) {
            users.splice(indexUserFound, 1)
          }

          dispatch(fetchUsers())
          dispatch(fetchLists())
        } else {
          // if is an agent, set count to 0
          dispatch(setUnreadMessages(message.userId, 1))
        }

        if (message?.attachments?.length) {
          dispatch(sharedResourcesAct.get({}))
        }
        break
      }

      // SOCKET CHANNEL --> operator._id
      case 'updateUserOrder': {
        updateUserOrder(event)
        break
      }

      /**
       *  SOCKET CHANNEL --> operator._id
       */
      case 'newUser': {
        const { message: newUser } = event.data

        if (onlyAssignedConversations && !newUser.assignedTo?.includes(operator._id)) {
          break
        }

        // order users
        if (!users.find(user => user._id === newUser._id)) {
          dispatch(fetchUsersSuccess({ users: [newUser].concat(users) }))
        }

        break
      }

      /**
       *  SOCKET CHANNEL --> operator._id
       */
      case 'updateUserList': {
        if (onlyAssignedConversations) {
          // Get new users in state list
          dispatch(fetchLists())
          break
        }

        const {
          message: { user: updateUserList },
        } = event.data

        const indexUser = users.findIndex((user) => user.id === updateUserList.id)

        // Remove user from users list
        if (indexUser !== -1) users.splice(indexUser, 1).pop()

        // Update users list
        dispatch(fetchUsersSuccess({ users: [updateUserList].concat(users) }))

        // Get new users in state list
        dispatch(fetchLists())

        break
      }

      /**
       *  SOCKET CHANNEL --> operator._id
       */
      case 'removeUserList': {
        if (onlyAssignedConversations) {
          // Get new users in state list
          dispatch(fetchLists())
          break
        }

        const { user: removeUserList } = event.data

        const indexUser = users.findIndex((user) => user.id === removeUserList.id)

        // Remove user from users list
        if (indexUser !== -1) users.splice(indexUser, 1)

        // Update users list
        dispatch(fetchUsersSuccess({ users }))

        // Get new users in state list
        dispatch(fetchLists())

        break
      }

      // SOCKET CHANNEL --> operator._id
      case 'updateUserStatus': {
        updateUserStatus(event)
        break
      }

      case 'conversationDelete': {
        const { messageId, type, userId, subjectId } = event.data

        switch (type) {
          case 'deleteMessage':{
            const { chat } = conversations[userId]
            const contentMessage = chat.messages.find((message) => message._id === messageId)
            if(contentMessage)
              dispatch(updateMessage(userId, { ...contentMessage, isRemoved:true, messageText:'message_delete', attachments:[], buttons:[] }))
            break
          }
          case 'deleteSubject':{
            const { composer } = conversations[userId]
            if(composer.currentSubject._id === subjectId){
              const { data } = await apiConversation.conversations.getSubjects({ userId })
              const newSubjects = []
              if(data.length){
                for (const d of data) {
                  if(!d.isRemoved && d._id !== subjectId)
                    newSubjects.push(d)
                }
              }
              dispatch(composerActions.setCurrentSubject(newSubjects[0] || {}))
            }
            break
          }
          case 'deleteUser': {
            dispatch(getMnemonics())
            const indexUser = users.findIndex((user) => user.id === userId)
            const indexUserAssigned = usersAssigned.findIndex((user) => user.id === userId)

            let deleteUser = {}
            // Remove user from users list
            if (indexUser !== -1){
              deleteUser = users[indexUser]
              users.splice(indexUser, 1)
            }
            // Remove user from users assigned list
            if (indexUserAssigned !== -1){
              deleteUser = users[indexUserAssigned]
              usersAssigned.splice(indexUserAssigned, 1)
            }

            // Update users list
            dispatch(fetchUsersSuccess({ users }))
            dispatch(fetchAssignedUsersSuccess(usersAssigned))

            // Get new users in state list
            dispatch(fetchLists())

            //If user tab is open, update it's information
            if (tabs.users?.some(e => e.id === userId)) dispatch(userUpdate(deleteUser))

            // update users in cv_search.search_users
            const userInCvSearch = search_users.find(el => el.id === deleteUser.id)
            if(userInCvSearch) dispatch(cvSearchUpdateUser(deleteUser))

            dispatch(poolLists.event({ onlyListIsAvailable: true }))
            break
          }
          default:
            break
        }
        break
      }

      case 'updateMessage':{
        const { message, user } = event.data
        dispatch(updateMessage(user.id, message))
        break
      }

      case 'updateOperatorStatus': {
        const { message: updateOperator } = event.data

        if (operators[updateOperator._id]) {
          operators[updateOperator._id] = { ...operators[updateOperator._id], ...updateOperator }
          dispatch(setAllOperatorsAct(operators))
        }

        break
      }

      // SOCKET CHANNEL --> operator._id
      case 'newAssignation': {
        addNewAssignation(event)
        break
      }

      // SOCKET CHANNEL --> operator._id
      case 'removeAssignation': {
        removeAssignation(event)
        break
      }

      /**
       *  SOCKET CHANNEL --> operator._id
       */
      case 'updateOperatorAndUsers': {
        const { operators: apiOperator } = operatorApi

        const { data } = await apiOperator.getOperators()

        const { operator, brands, delegations } = data

        dispatch(setAllBrandsAct(brands))
        dispatch(setAllDelegationsAct(delegations))
        dispatch(setUserData(operator))
        dispatch(fetchUsers())

        break
      }

      /**
       *  SOCKET WALL_API CHANNEL --> user._id
       */
      case 'newNode': {
        dispatch(addNode(event.data))
        break
      }
      case 'updateNode': {
        dispatch(updateNode(event.data))
        break
      }
      case 'newWall': {
        dispatch(addWall(event.data))
        break
      }
      case 'updateActivationModules': {
        const { message } = event.data
        dispatch(modulesAct.upsert(message))
        break
      }
      case 'companyUpdate': {
        const { message } = event.data
        dispatch(updateExistingCompanyAct(message))
        break
      }
      case 'aiSuggestions': {
        const { suggestions = {}, userId } = event.payload

        dispatch(composerAct.setSuggestions(userId, suggestions))
        break
      }
      case 'mnemonics': {
        dispatch(updateTicket(event.data))
        break
      }

      case 'updatePoolLists': {
        dispatch(poolLists.event())

        break
      }

      case 'mailInfo': {
        dispatch(channels.updateChatmailSync(event.data))
        break
      }

      case 'category': {
        dispatch(categories.categoriesEvent(event.data))
        break
      }

      case 'deferred_message': {
        const {
          userId
        } = event.data
        if(activeUser === userId){
          dispatch(getDeferredMessages())
        }
        break
      }

      case 'dashNotification': {
        const { data } = event
        dispatch(dashNotification.getHasNew(true, data.notificationId))
        break
      }

      case 'inChat': {
        const {
          data: {
            conversationId, dateLastDeferred, deferredAction, isMute,
            message, operator, totalDeferred, type, users, messageId, action
          }
        } = event

        switch (type) {
          case 'newMessage':
            dispatch(inchatActions.updateUnreadMessages(conversationId, 1, activeUser))
            if (message.isThread)
              dispatch(inchatActions.setNewThreadMessage(message))
            else
              dispatch(inchatActions.setNewDirectMessage(message))
            dispatch(inchatActions.getTotalReactions())
            break
          case 'join':
            dispatch(inchatActions.addConversationChannel(conversationId))
            break
          case 'mute':
          case 'unmute':
            dispatch(inchatActions.updateChannelMute(conversationId, isMute))
            break
          case 'kick':
            dispatch(inchatActions.updateUsersConversation(conversationId, users, type))
            break
          case 'invite':
            dispatch(inchatActions.updateUsersConversation(conversationId, users, type))
            break
          case 'deferredMessage':
            if (deferredAction === 'add') {
              dispatch(inchatActions.updateConversation(conversationId, {
                firstDeferredMsgDate: dateLastDeferred,
                totalDeferredMsgs: totalDeferred,
                deferredMsgsOperator: operator
              }))
            }
            break
          case 'reactionAdded':
          case 'reactionDeleted':
            dispatch(inchatActions.updateMessageReactions(event.data))
            dispatch(inchatActions.getTotalReactions())
            break
          case 'deleteMessage':
            dispatch(inchatActions.updateDeleteMessage(conversationId, messageId))
            break
          case 'editMessage':
            dispatch(inchatActions.updateMessage(message))
            break
          case 'pinMessage':
            if (action === 'add') {
              dispatch(inchatActions.updateCountPinnedMessages(conversationId, 1))
              dispatch(inchatActions.updatePinnedMessage(conversationId, message._id, message.isThread, true))
            } else {
              dispatch(inchatActions.updateCountPinnedMessages(conversationId, -1))
              dispatch(inchatActions.updatePinnedMessage(conversationId, message._id, message.isThread, false))
            }
            break
          case 'newMessageThread':
            dispatch(inchatActions.updateMessage(message))
            break
          case 'saveMessage':
            if (action === 'add') {
              dispatch(inchatActions.updateCountSavedMessages(1))
              dispatch(inchatActions.updateSavedMessage(conversationId, messageId, message.isThread, true))
            } else {
              dispatch(inchatActions.updateCountSavedMessages(-1))
              dispatch(inchatActions.updateSavedMessage(conversationId, messageId, message.isThread, false))
            }
            break
          case 'draftMessage':
            if (action === 'add') {
              dispatch(inchatActions.updateCountDraftMessages(1))
            } else {
              dispatch(inchatActions.updateCountDraftMessages(-1))
            }
            break
          default:
            console.error('Socket Event -> No action found for data:', event)
            break
        }
        break
      }
      case 'updatePool': {
        dispatch(poolsActions.updateRefreshCounter())

        if (event.data?.massiveAction === 'remove_mnemonics') {
          dispatch(getMnemonics())
        }

        break
      }

      case 'deliveryNotification': {
        const { userId, messageId, status, errorMessage } = event.data
        if (userId) {
          dispatch(updateMessageStatus({ userId, messageId, status, errorMessage }))
        }
        break
      }

      case 'webTracking': {
        const { trackingUser, userId, trackingEvents } = event.payload

        if (trackingUser) {
          dispatch(trackingUserInfoAct.get(userId))
        }

        if (Object.keys(trackingEvents).length) {
          dispatch(trackingUserHistoryAct.addTrackingEvent(userId, trackingEvents))
        }

        break
      }

      case 'planChanged': {
        const { plan } = event.data

        dispatch(CurrentPlanAct.update(plan))

        break
      }
      default:
        console.error('Socket Event -> No action found for data:', event)
    }
  } catch (e) {
    console.error('Socket Error -> ', event.action, e.message)
  }
}
